import { render, staticRenderFns } from "./orderAdd.vue?vue&type=template&id=1c9bc41c&scoped=true"
import script from "./orderAdd?vue&type=script&lang=js&external"
export * from "./orderAdd?vue&type=script&lang=js&external"
import style0 from "./orderAdd.vue?vue&type=style&index=0&id=1c9bc41c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9bc41c",
  null
  
)

export default component.exports